<template>
  <div :class="classes">
    <pt-page-title :title="(isEdit?'编辑':'新建')+'商品分组'"></pt-page-title>
    <pt-sub-title title="商品分组"></pt-sub-title>
    <table :class="$style['new-group-table']">
      <pt-form-list-item label="分组名称" :required="true">
        <wt-input data-vv-as="分组名称" name="name" v-validate="'required'" v-model="formValue.name"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="展示图标" :required="true">
        <wt-upload-file :action="uploadApi" :data="upload_params" :img-url="privateResourcesUrl" :multiple="false" v-model="formValue.icon" data-vv-as="展示图标"
                        name="name" v-validate="'required'">
          <i v-if="!formValue.icon" class="iconfont icon-Group1 main-color" :class="$style['add-group-pictrue']"></i>
        </wt-upload-file>
      </pt-form-list-item>
      <pt-form-list-item label="商品排序">
        <wt-selector :options="goodsSortList" v-model="formValue.sortingStrategy" @change="changeSort"></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="C端是否展示:">
        <wt-radio :radios="Cshow" v-model="formValue.visible_show"></wt-radio>
      </pt-form-list-item>
    </table>
    <template v-if="isEdit">
      <pt-sub-title title="商品分组"></pt-sub-title>
      <pt-goods-manage-table :tableLabels="tableLabels" ref="goodsTable" :page-size="pageSize" :query-params="queryParams" :isGroupSort="true">
        <template>
          <el-table-column label="推荐值">
            <template slot-scope="scope">
              <div :class="$style['ranking-div']" @mouseenter="editRanking(scope.row)" @mouseleave="noEditRank(scope.row)">
                {{scope.row.goodsOtherInfoDTO&&scope.row.goodsOtherInfoDTO.ranking}}
                <el-popover placement="bottom" trigger="click" v-if="scope.row.isEditRank" @mouseenter="editRanking(scope.row)">
                  <edit-ranking :rowInfo="scope.row.goodsOtherInfoDTO" @sumitRank="sumitRank"></edit-ranking>
                  <i class="iconfont icon-bianji" slot="reference" @click="editRinkValue(scope.row)"></i>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品状态">
            <template slot-scope="scope">
              {{scope.row.goods_state}}
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="goodsReview(scope.row)">预览</el-button>
            </template>
          </el-table-column>
        </template>
      </pt-goods-manage-table>
    </template>
    <review-goods-iframe :is-dialog="is_review" @closeDialog="closeDialog" :goods-id="review_id"></review-goods-iframe>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { goodsSort, Cshow, groupGoodsLabels } from '../group-options.js'
import reviewGoodsIframe from 'cps/mall-manage/pt-goods-manage/review-goods-iframe'
import ptGoodsManageTable from 'cps/mall-manage/pt-goods-manage/pt-goods-manage-table/withData.vue'
import editRanking from 'cps/mall-manage/pt-goods-manage/edit-ranking'
// 组件class前缀
const prefixCls = 'pt-group-form'

export default {
  name: 'pt-group-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    reviewGoodsIframe,
    editRanking,
    ptGoodsManageTable
  },
  props: {
    form: {
      type: Object,
      default: function () {
        return {
        }
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      upload_params: {
        resourceName: 'goodsgroup'
      },
      uploadApi: this.$uploadApi,
      goodsSortList: goodsSort,
      privateResourcesUrl: this.$publicResourcesUrl,
      formValue: this.form,
      Cshow: Cshow,
      tableLabels: groupGoodsLabels,
      is_review: false,
      review_id: '',
      pageSize: 10,
      queryParams: {
        groupId: this.id
      }
    }
  },
  watch: {
    form: {
      handler: function (val) {
        this.formValue = val
        this.$set(this.queryParams, 'sortWay', val.sortingStrategy)
      },
      deep: true
    }
  },
  methods: {
    changeSort (val) {
      this.$emit('changeSort', val)
      this.queryParams.sortWay = val
      if (val) {
        this.$refs.goodsTable.getGoodsList(0)
      }
    },
    editRanking (val) {
      this.$set(val, 'isEditRank', true)
      val.isEditRank = true
    },
    noEditRank (val) {
      if (!val.isedit) {
        this.$set(val, 'isEditRank', false)
      }
    },
    editRinkValue (val) {
      this.$set(val, 'isedit', true)
      this.$set(val, 'isEditRank', true)
      this.row_now = val
    },
    sumitRank () {
      this.$set(this.row_now, 'isEditRank', false)
      let page = this.$refs.goodsTable.page
      this.$refs.goodsTable.getGoodsList(page)
    },
    goodsReview (val) {
      this.is_review = true
      this.review_id = val.goodsDTO.id
    },
    closeDialog () {
      this.is_review = false
    }

  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.new-group-table{
    max-width: 300px;
    :global
    .el-upload--picture-card{
        width: 0;
        height: 0;
        border: none;
        line-height:30px;
        display: initial
    }
}
.add-group-pictrue{
    font-size: 30px;
}
.goods-price-name{
    display: flex;
    line-height: inherit;
    width: 100%;
    padding: 10px;
}
.goods-name-price{
    // display: flex;
    padding-left: 20px;
    flex-direction: column;
    display: -webkit-inline-box;
    white-space:initial;
    justify-content: space-between;
    :global
    div{
        word-break:break-word
    }
}
.banner-picture-div{
    display: flex;
    justify-content: center;
    align-items: center;
}
.banner-picture{
   border-radius: 5px;
}
</style>
